import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { OverlayView } from 'react-google-maps';
import MinimalCard from '../../CardSlider/CardContainer/Card/MinimalCard.jsx';

function getCardPixelPositionOffset() {
    return { x: -115, y: -258 };
}

class MapCard extends Component {
    static propTypes = {
        card: PropTypes.object.isRequired,
        currencySymbol: PropTypes.string.isRequired,
        domain: PropTypes.string.isRequired,
        handleMarkerClick: PropTypes.func.isRequired,
        handleMarkerClose: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        marker: PropTypes.object.isRequired
    }

    render() {
        const {
            card,
            currencySymbol,
            domain,
            handleMarkerClick,
            handleMarkerClose,
            lang,
            marker
        } = this.props;
        return (
            <OverlayView
                {...marker}
                roomId={marker.id}
                position={{ lat: marker.position.lat, lng: marker.position.lng }}
                getPixelPositionOffset={getCardPixelPositionOffset}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
                <MinimalCard
                    card={card}
                    cardId={marker.id}
                    cardPadding={66.6667}
                    currencySymbol={currencySymbol}
                    domain={domain}
                    handleMarkerClick={handleMarkerClick}
                    handleMarkerClose={handleMarkerClose}
                    lang={lang}
                />
            </OverlayView>
        );
    }
}

export default MapCard;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/MapCard.jsx